import React, { useState } from "react";
import {
    Button,
    Card,
    Form,
} from "reactstrap";
import SuccessfullyUnsubscribeImag from './assests/images/successfully-unsubscribed.gif';
import unsubscribeImag from './assests/images/unsubscribe-image.gif';

const Unsubscribe = (props) => {
    // const [isSubscribed, setIsSubscribed] = useState(false);
    // const [selectedOption, setSelectedOption] = useState();

    // const validateOnchange = (e, data) => {
    //     const { name, checked } = e.target;
    //     setSelectedOption(name);
    // }

    // const handleUnsubscribe = () => {
    //     setIsSubscribed(true)
    // }

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <Card className="shadow-lg p-4">
                {/* {isSubscribed ? */}
                <div className=" d-flex align-items-center">
                    <img src={SuccessfullyUnsubscribeImag} alt="no-user-found" style={{ height: "300px", width: "auto" }} />
                    <div className="fs-4  fw-bold text-success">
                        You have been successfully unsubscribed<br />
                        from the newsletter.
                    </div>
                </div>
                {/* :
                    <div className="d-flex align-items-center">
                        <img src={unsubscribeImag} alt="no-user-found" style={{ height: "300px", width: "auto" }} />
                        <div>
                            <Form>
                                <h4 style={{ color: '#f72d7e' }}>Please confirm to unsubscribe from these email notifications.</h4><br />
                                <Button
                                    cla4sName='mt-4'
                                    color='danger'
                                    onClick={handleUnsubscribe}
                                >Unsubscribe
                                </Button>
                            </Form>
                        </div>
                    </div>
                } */}
            </Card >
        </div>
    )
}

export default Unsubscribe;